import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HelpPage } from './help';

@NgModule({
  declarations: [
    HelpPage,
  ],
  imports: [
    IonicPageModule.forChild(HelpPage),
  ],
  exports: [
    HelpPage
  ]
})
export class HelpPageModule { }



// WEBPACK FOOTER //
// ./src/pages/help/help.module.ts